export enum AttachmentTypes {
  BusinessException = 2,
  ManagerApproval = 1,
}
